var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_shopify.html';
var html = "<ng-container translate=sites.campaigns.edit.instruction.shopify translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-link=\"<a href='https://help.shopify.com/ja/manual/promoting-marketing/discount-codes' target='_blank'>{{ 'sites.campaigns.edit.instruction.here' | translate }}</a>\"></ng-container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/instruction_shopify.html
// module id = 1395
// module chunks = 0